
// import React, { useEffect, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   IconArrow,
//   IconBook,
//   IconGlobe,
//   IconDoc,
//   IconLink,
//   IconChart,
//   IconBalance,
//   IconBuilding,
//   IconBriefcase,
//   IconLightbulb,
//   IconPhone,
//   IconMail,
//   IconLinkedIn,
//   SectionEyebrow,
// } from "./icons";
// import FlagshipInitiatives from "./FlagshipInitiatives";
// import { LightbulbIcon } from "./icon2";

// /* ------------------------------- Data blocks ------------------------------ */
// const stats = [
//   {
//     icon: IconDoc,
//     number: "350+",
//     title: "Publications",
//     text: "Research reports, policy briefs, working papers, and flagship periodicals published annually.",
//   },
//   {
//     icon: IconGlobe,
//     number: "45+",
//     title: "Countries Covered",
//     text: "In-depth economic analysis spanning G20 nations, emerging markets, and developing economies.",
//   },
//   {
//     icon: IconBook,
//     number: "120+",
//     title: "Policy Studies",
//     text: "Evidence-based policy recommendations for central and state governments and institutions.",
//   },
//   {
//     icon: IconLink,
//     number: "80+",
//     title: "Partnerships",
//     text: "Strategic collaborations with think tanks, universities, and multilateral organisations.",
//   },
// ];

// const focusAreas = [
//   {
//     icon: IconChart,
//     title: "Research for Economic Development",
//     body: "Enhancing India's growth path through strengthening manufacturing, trade, investment, and financial systems.",
//   },
//   {
//     icon: IconBalance,
//     title: "Public Policy Analysis",
//     body: "Providing actionable insights on global, national, and state-level policy developments to support evidence-based decision-making.",
//   },
//   {
//     icon: IconBuilding,
//     title: "Ease of Doing Business (EoDB)",
//     body: "Supporting businesses through research-backed strategies, fostering innovation, and improving market access.",
//   },
//   {
//     icon: IconBriefcase,
//     title: "Trade & Investment Promotion Services (TIPS)",
//     body: "Supporting trade and investment by offering strategic insights into India's high-growth sectors and fostering global partnerships.",
//   },
//   {
//     icon: IconLightbulb,
//     title: "Industry-Academia Collaboration",
//     body: "Enhancing connections between academia and industry to promote R&D, innovation, and employment creation.",
//   },
// ];

// const flagship = [
//   {
//     icon: IconChart,
//     title: "Economic Growth & Development",
//     body: "Economic Growth & Development is a flagship research initiative of the ASSOCHAM Global Research & Strategy Centre dedicated to advancing evidence-based policy research on India's economic transformation. Through analytical reports, working papers, and thematic studies, the initiative examines the Indian economic and policy landscape. Through actionable insights on national, state, and global economic developments, the initiative contributes to strengthening India's competitiveness and fostering sustainable and inclusive economic development.",
//     buttonText: "Explore Reports",
//     to: "/global-research/economic-growth",
//   },
//   {
//     icon: IconBuilding,
//     title: "Ease of Doing Business (EoDB)",
//     body: "The Ease of Doing Business (EoDB) initiative supports the creation of a more efficient, transparent, and business-friendly regulatory environment through research, policy analysis, and stakeholder engagement. It develops deregulation studies, policy ready reckoners, sector-specific reports, and knowledge resources that help businesses better understand regulatory frameworks and market opportunities. The initiative also organises consultations, conferences, and dialogues to facilitate collaboration between government, industry, and experts.",
//     buttonText: "Learn More",
//     to: "/global-research/eodb",
//   },
//   {
//     icon: IconGlobe,
//     title: "Trade & Investment Promotion Services (TIPS)",
//     body: "Trade & Investment Promotion Services (TIPS) is a flagship initiative of the ASSOCHAM Global Research & Strategy Centre that serves as a dedicated information and advisory platform for trade and investment. It provides businesses, investors, and government institutions with strategic insights into high-growth sectors, investment opportunities, and the evolving policy and regulatory landscape. By facilitating knowledge sharing, institutional partnerships, and stakeholder engagement, TIPS supports informed investment decisions and promotes domestic and international business collaborations.",
//     buttonText: "Visit TIPS",
//     to: "/global-research/tips",
//   },
//   {
//     icon: IconBook,
//     title: "Publications",
//     body: "The Publications vertical disseminates timely research and economic intelligence to support informed decision-making across government, industry, academia, and the wider business community. It offers regular analysis of macroeconomic trends, policy developments, sectoral performance, business indicators, and the global economic outlook through a range of flagship publications.",
//     bullets: [
//       "ASSOCHAM Business Currents Daily (ABC Daily)",
//       "ASSOCHAM India Monitor (AIM Weekly)",
//       "ASSOCHAM Global Economic Outlook (ASSOCHAM GEO Monthly)",
//     ],
//     buttonText: "View Publications",
//     to: "/global-research/publications",
//   },
// ];

// const team = [
//   {
//     name: "Dr. S.P. Sharma",
//     role: "Chief Economist",
//     phone: "011-46550555",
//     email: "chiefeconomist@assocham.com",
//     photo: "/OurTeam/S_P_Sharma.jpg",
//     lead: true,
//   },
//   {
//     name: "Ms. Ruchi Singhal",
//     role: "Additional Director",
//     dept: "Research & Strategy",
//     photo: "/OurTeam/RuchiSinghal.png",
//   },
//   {
//     name: "Ms. Yatika Gupta",
//     role: "Joint Director",
//     dept: "Research & Strategy",
//     photo: "https://assocham.org/images/awards/img14.png",
//   },
//   {
//     name: "Mr. Arun Singh Rathore",
//     role: "Deputy Director",
//     dept: "Research & Strategy",
//     photo: "/OurTeam/Arun_Singh_Rathore.jpg",
//   },
//   {
//     name: "Ms. Avneet Kaur",
//     role: "Senior Executive",
//     dept: "Research & Strategy",
//     photo: "/OurTeam/Avneet_Kaur.jpg",
//   },
// ];

// const contactInfo = [
//   {
//     icon: IconBuilding,
//     label: "Headquarters",
//     lines: [
//       "4th Floor, YMCA Cultural Centre",
//       "and Library Building, 01 Jai Singh Road,",
//       "New Delhi - 110001",
//     ],
//   },
//   {
//     icon: IconPhone,
//     label: "Phone",
//     lines: ["011-46550555"],
//     href: "tel:+911146550555",
//     action: "Call the Centre",
//   },
//   {
//     icon: IconMail,
//     label: "Email",
//     lines: ["chiefeconomist@assocham.com"],
//     href: "mailto:chiefeconomist@assocham.com",
//     action: "Write to us",
//   },
// ];

// /* --------------------------- Image resilience ---------------------------- */
// const initialsOf = (name = "") =>
//   name
//     .replace(/[^a-zA-Z.\s]/g, "")
//     .split(/[\s.]+/)
//     .filter(Boolean)
//     .slice(-2)
//     .map((w) => w[0])
//     .join("")
//     .toUpperCase() || "?";

// const avatarFallback = (name = "") => {
//   const initials = initialsOf(name);
//   const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'><defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='#e8590c'/><stop offset='1' stop-color='#7c140d'/></linearGradient></defs><rect width='240' height='240' fill='url(#g)'/><text x='50%' y='54%' font-family='Space Grotesk, Arial' font-size='92' font-weight='600' fill='white' text-anchor='middle' dominant-baseline='middle'>${initials}</text></svg>`;
//   return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
// };

// const onImgError = (e, name) => {
//   const el = e.currentTarget;
//   if (el.dataset.fallback === "1") return;
//   el.dataset.fallback = "1";
//   el.src = avatarFallback(name);
// };

// /* ------------------------------- Animations ------------------------------ */
// const useIntersectionObserver = (options = {}) => {
//   const [isVisible, setIsVisible] = useState(false);
//   const ref = useRef(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//           observer.disconnect();
//         }
//       },
//       { threshold: 0.1, ...options }
//     );

//     if (ref.current) {
//       observer.observe(ref.current);
//     }

//     return () => observer.disconnect();
//   }, [options]);

//   return [ref, isVisible];
// };

// const AnimatedSection = ({ children, className = "", delay = 0 }) => {
//   const [ref, isVisible] = useIntersectionObserver();

//   return (
//     <div
//       ref={ref}
//       className={`transition-all duration-700 ease-out ${
//         isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
//       } ${className}`}
//       style={{ transitionDelay: `${delay}ms` }}
//     >
//       {children}
//     </div>
//   );
// };

// const AnimatedCard = ({ children, className = "", delay = 0 }) => {
//   const [ref, isVisible] = useIntersectionObserver();

//   return (
//     <div
//       ref={ref}
//       className={`transition-all duration-700 ease-out ${
//         isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
//       } ${className}`}
//       style={{ transitionDelay: `${delay}ms` }}
//     >
//       {children}
//     </div>
//   );
// };

// /* --------------------------------- Sections ------------------------------- */

// /* Breadcrumb — matches the AboutSection breadcrumb styling */
// function Breadcrumb() {
//   return (
//     <nav
//       aria-label="Breadcrumb"
//       className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
//     >
//       <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
//         <li>
//           <a
//             href="#top"
//             className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
//           >
//             <svg
//               viewBox="0 0 24 24"
//               className="h-4 w-4"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2.2}
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <path d="M3 10.5 12 3l9 7.5" />
//               <path d="M5 10v10h14V10" />
//               <path d="M9 20v-6h6v6" />
//             </svg>
//             Home
//           </a>
//         </li>
//         <li className="text-black/30">&rsaquo;</li>
//         <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">
//           Global Research
//         </li>
//       </ol>
//     </nav>
//   );
// }

// /* Hero — now uses the same soft background + breadcrumb treatment as AboutSection */
// function Hero() {
//   return (
//     <header id="top" className="relative overflow-hidden bg-[#FAF7F2]">
//       {/* backdrop decorations, same as AboutSection */}
//       <div className="hero-grid absolute inset-0" />
//       <div className="pointer-events-none absolute -top-32 left-1/2 h-[360px] w-[680px] -translate-x-1/2 rounded-full bg-[#DA2128]/10 blur-[130px]" />
//       <div className="pointer-events-none absolute -bottom-40 -right-24 h-[320px] w-[320px] rounded-full bg-[#DA2128]/[0.07] blur-[110px]" />

//       <Breadcrumb />

//       <div className="relative w-full max-w-[1280px] mx-auto px-6 lg:px-10 pb-16 pt-28 sm:pt-32">
//         <AnimatedSection delay={200}>
//           <div className="max-w-3xl mx-auto text-center">
//             <div className="inline-flex items-center gap-2.5 rounded-full border border-[#B42318]/15 bg-white/70 backdrop-blur px-4 py-1.5 mb-6 shadow-sm">
//               <span className="w-1.5 h-1.5 rounded-full bg-[#E8590C] animate-pulse" />
//               <SectionEyebrow variant="orange">Research & Strategy</SectionEyebrow>
//             </div>

//             <h1 className="mt-6 font-display text-gray-900 text-4xl sm:text-5xl md:text-[56px] leading-[1.05] tracking-tight [text-wrap:balance]">
//               Global Research &{" "}
//               <span className="relative text-[#B42318]">
//                 Strategy Centre
//                 <svg className="absolute -bottom-2 left-0 w-full h-1.5" viewBox="0 0 100 4" preserveAspectRatio="none">
//                   <line x1="0" y1="2" x2="100" y2="2" stroke="currentColor" strokeWidth="2.5" strokeDasharray="7 7" className="text-[#E8590C]/50" />
//                 </svg>
//               </span>
//             </h1>

//             <p className="mt-6 text-gray-600 max-w-2xl mx-auto leading-relaxed text-[15px] md:text-[16.5px]">
//               A dedicated platform for research, policy analysis, and strategic insights aimed at strengthening India's position in the global economy.
//             </p>

//             <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
//               <a
//                 href="#focus"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   document.getElementById("focus")?.scrollIntoView({ behavior: "smooth" });
//                 }}
//                 className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#B42318] to-[#E8590C] hover:from-[#94190f] hover:to-[#c94c09] transition-all duration-300 text-white text-sm font-semibold px-6 py-3 shadow-lg shadow-[#E8590C]/25 hover:shadow-xl hover:-translate-y-0.5"
//               >
//                 Explore Focus Areas
//                 <IconArrow
//                   className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1"
//                   stroke={2.2}
//                 />
//               </a>
//               <a
//                 href="#initiatives"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   document.getElementById("initiatives")?.scrollIntoView({ behavior: "smooth" });
//                 }}
//                 className="inline-flex items-center gap-2 rounded-full border border-[#B42318]/25 hover:border-[#B42318]/50 hover:bg-white/60 transition-colors duration-300 text-gray-800 text-sm font-semibold px-6 py-3 backdrop-blur"
//               >
//                 View Initiatives
//               </a>
//             </div>
//           </div>
//         </AnimatedSection>
//       </div>

//       {/* bottom shimmer line, same as AboutSection */}
//       <div className="shimmer-line h-px w-full" />
//     </header>
//   );
// }

// function About() {
//   return (
//     <section className="py-24 md:py-28 bg-[#FAF7F2]">
//       <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
//         <AnimatedSection>
//           <div>
//             <SectionEyebrow variant="orange">About the Centre</SectionEyebrow>
//             <h2 className="text-balance font-display text-3xl md:text-[40px] leading-tight text-gray-900 mt-5">
//               Driving India's Position in the{" "}
//               <span className="text-[#B42318] relative">
//                 Global Economy
//                 <svg className="absolute -bottom-2 left-0 w-full h-1" viewBox="0 0 100 4">
//                   <line x1="0" y1="2" x2="100" y2="2" stroke="currentColor" strokeWidth="2" strokeDasharray="6 6" className="text-[#B42318]/50" />
//                 </svg>
//               </span>
//             </h2>
//             <div className="mt-6 space-y-4 text-gray-600 leading-relaxed max-w-xl">
//               <p>
//                 The ASSOCHAM Global Research & Strategy Centre is a dedicated
//                 platform for research, policy analysis, and strategic insights
//                 aimed at strengthening India's position in the global economy.
//               </p>
//               <p>
//                 Through high-quality research, thought leadership, and
//                 evidence-based recommendations, the Centre supports informed
//                 policymaking, promotes sustainable economic growth, and
//                 contributes to India's development journey.
//               </p>
//             </div>
//           </div>
//         </AnimatedSection>

//         <AnimatedSection delay={200}>
//           <div className="relative">
//             <div className="absolute -inset-4 rounded-[28px] bg-gradient-to-br from-[#E8590C]/25 via-[#B42318]/15 to-[#F59C00]/25 blur-2xl animate-pulse" />
//             <div className="relative rounded-3xl overflow-hidden ring-1 ring-[#E8590C]/20 shadow-2xl shadow-[#B42318]/10">
//               <img
//                 src="https://images.pexels.com/photos/7876664/pexels-photo-7876664.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=800&w=1200"
//                 alt="Global economy research"
//                 className="w-full h-[380px] object-cover transition-transform duration-700 hover:scale-110"
//               />
//               <div className="absolute inset-0 bg-gradient-to-tr from-[#7c140d]/40 via-transparent to-transparent" />
//               <div className="absolute bottom-5 left-5 right-5 flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-full bg-white/90 backdrop-blur flex items-center justify-center text-[#B42318]">
//                   <IconChart className="w-5 h-5" />
//                 </div>
//                 <div className="text-white">
//                   <div className="text-sm font-semibold">
//                     Global Economic Insights
//                   </div>
//                   <div className="text-xs text-white/80">
//                     Data-driven policy briefings
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </AnimatedSection>
//       </div>
//     </section>
//   );
// }

// function FocusCard({ f, index }) {
//   return (
//     <AnimatedCard delay={index * 90}>
//       <div className="group relative h-full bg-white rounded-2xl p-7 ring-1 ring-[#E8590C]/10 shadow-sm hover:shadow-xl hover:shadow-[#E8590C]/10 transition-all duration-300 hover:-translate-y-2 overflow-hidden">
//         <span
//           aria-hidden="true"
//           className="pointer-events-none absolute top-4 right-5 z-0 font-display text-[52px] leading-none font-bold text-transparent [-webkit-text-stroke:1px_rgba(180,35,24,0.16)] transition-all duration-300 group-hover:[-webkit-text-stroke:1.5px_rgba(232,89,12,0.5)]"
//         />
//         <div className="pointer-events-none absolute -top-12 -right-12 w-32 h-32 rounded-full bg-gradient-to-br from-[#E8590C]/5 to-[#B42318]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

//         <div className="relative z-10">
//           <div className="w-12 h-12 rounded-xl bg-[#FAF7F2] flex items-center justify-center text-[#7c140d] ring-1 ring-[#E8590C]/20 transition-all duration-300 group-hover:bg-[#E8590C] group-hover:text-white group-hover:scale-110 group-hover:rotate-12">
//             <f.icon className="w-6 h-6" />
//           </div>
//           <h3 className="mt-5 font-display text-xl text-gray-900 leading-snug pr-10">
//             {f.title}
//           </h3>
//           <p className="mt-3 text-sm leading-relaxed text-gray-600">{f.body}</p>
//           <div className="mt-5 h-1 w-10 rounded-full bg-gradient-to-r from-[#B42318] to-[#E8590C] transition-all duration-300 group-hover:w-20" />
//         </div>
//       </div>
//     </AnimatedCard>
//   );
// }

// function FocusAreas() {
//   return (
//     <section id="focus" className="pb-24 md:pb-28 relative bg-[#FFF8F5]">
//       <div className="absolute inset-0">
//         <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
//           <defs>
//             <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
//               <circle cx="2" cy="2" r="1.5" fill="rgba(180,35,24,0.03)" />
//             </pattern>
//           </defs>
//           <rect width="100%" height="100%" fill="url(#dots)" />
//         </svg>
//       </div>
 
//       <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">
//         <AnimatedSection>
//           <div className="text-center max-w-2xl mx-auto">
//             <SectionEyebrow variant="red">Key Focus Areas</SectionEyebrow>
//             <h2 className="text-balance font-display text-3xl md:text-[40px] leading-tight text-gray-900 mt-5">
//               Unlocking Emerging{" "}
//               <span className="text-[#E8590C] relative">
//                 Opportunities
//                 <svg className="absolute -bottom-2 left-0 w-full h-1" viewBox="0 0 100 4">
//                   <line x1="0" y1="2" x2="100" y2="2" stroke="currentColor" strokeWidth="2" strokeDasharray="8 8" className="text-[#E8590C]/50" />
//                 </svg>
//               </span>
//             </h2>
//             <p className="mt-4 text-gray-600">
//               The ASSOCHAM Global Research & Strategy Centre focuses on unlocking
//               emerging opportunities and driving sustainable economic growth
//               through the following key areas.
//             </p>
//           </div>
//         </AnimatedSection>
 
//         <div className="mt-12 flex flex-wrap justify-center gap-5">
//           {focusAreas.map((f, i) => (
//             <AnimatedCard
//               key={i}
//               delay={i * 90}
//               className="w-full sm:w-[calc(50%-10px)] lg:w-[calc(33.333%-14px)]"
//             >
//               <FocusCard f={f} />
//             </AnimatedCard>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// const NOTCH_MASK =
//   "radial-gradient(circle 30px at calc(100% - 26px) calc(100% - 26px), transparent 0, transparent 27.5px, #000 28.5px, #000 100%)";

// function FlagshipCard({ item, index }) {
//   const Icon = item.icon;
//   return (
//     <AnimatedCard delay={index * 100} className="h-full">
//       <div className="group relative h-full transition-transform duration-300 ease-out hover:-translate-y-1.5 shadow-[0_22px_45px_-20px_rgba(124,20,13,0.55)] hover:shadow-[0_34px_60px_-18px_rgba(180,35,24,0.6)]">
//         <div
//           className="relative h-full min-h-[300px] flex flex-col rounded-[28px] p-7 md:p-8 overflow-hidden"
//           style={{
//             background:
//               "linear-gradient(rgb(218, 33, 40), rgb(247, 148, 29))",
//             WebkitMaskImage: NOTCH_MASK,
//             maskImage: NOTCH_MASK,
//           }}
//         >
//           <div className="pointer-events-none absolute -top-20 -left-12 w-60 h-60 rounded-full bg-[#E8590C]/15 blur-3xl opacity-60 transition-opacity duration-500 group-hover:opacity-100" />
//           <div className="pointer-events-none absolute -bottom-24 left-1/4 w-64 h-64 rounded-full bg-[#B42318]/20 blur-3xl" />
//           <div className="pointer-events-none absolute inset-0 rounded-[28px] ring-1 ring-inset ring-white/[0.05]" />
//           <div className="pointer-events-none absolute top-0 left-8 right-8 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent opacity-60 transition-opacity duration-500 group-hover:opacity-100" />

//           <h3 className="relative font-display text-[19px] md:text-[22px] font-medium text-white leading-snug pr-6">
//             {item.title}
//           </h3>

//           <p className="relative mt-3 text-[13.5px] leading-relaxed text-white">
//             {item.body}
//           </p>

//           {item.bullets && (
//             <ul className="relative mt-4 space-y-2">
//               {item.bullets.map((b, i) => (
//                 <li
//                   key={i}
//                   className="flex items-start gap-2.5 text-[13px] leading-snug text-white"
//                 >
//                   <span className="mt-[7px] w-1.5 h-1.5 rounded-full bg-[#F59C00] shrink-0 shadow-[0_0_8px_rgba(245,158,11,0.6)]" />
//                   {b}
//                 </li>
//               ))}
//             </ul>
//           )}

//           <div className="relative mt-auto pt-7 flex items-end justify-between gap-4 pr-14">
//             <Icon
//               stroke={1.25}
//               className="w-14 h-14 md:w-[68px] md:h-[68px] text-white shrink-0 transition-all duration-300 group-hover:text-[#DA2128] group-hover:-translate-y-0.5 group-hover:scale-[1.04] drop-shadow-[0_2px_10px_rgba(0,0,0,0.35)]"
//             />
//             <span className="text-right text-[13px] font-semibold tracking-wide text-white/70 transition-colors duration-300 group-hover:text-white">
//               {item.buttonText}
//             </span>
//           </div>
//         </div>

//         <Link
//           to={item.to}
//           aria-label={item.buttonText}
//           className="absolute right-1 bottom-1 z-10 grid place-items-center w-11 h-11 rounded-full bg-[#190705] text-white/85 ring-1 ring-white/12 transition-all duration-300 group-hover:bg-[#F59C00] group-hover:text-white group-hover:ring-[#F59C00]/50 group-hover:scale-105 group-hover:-rotate-[8deg]"
//         >
//           <IconArrow className="w-[18px] h-[18px]" stroke={2.2} />
//         </Link>
//       </div>
//     </AnimatedCard>
//   );
// }

// function Flagships() {
//   return (
//     <section id="initiatives" className="py-24 md:py-28 bg-[#FAF7F2] relative overflow-hidden">
//       <div className="absolute inset-0">
//         <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-[#E8590C]/5" />
//         <div className="absolute -bottom-40 -left-40 w-96 h-96 rounded-full bg-[#B42318]/5" />
//         <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-gradient-to-r from-[#E8590C]/3 to-[#B42318]/3 blur-3xl" />
//         <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
//           <defs>
//             <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
//               <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(180,35,24,0.03)" strokeWidth="1" />
//             </pattern>
//           </defs>
//           <rect width="100%" height="100%" fill="url(#grid)" />
//         </svg>
//       </div>

//       <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">
//         <AnimatedSection>
//           <div className="text-center max-w-2xl mx-auto">
           
//             <h2 className="font-display text-3xl md:text-[40px] leading-tight text-gray-900 mt-5">
//                Flagship Publications & Initiatives
//             </h2>
//             <p className="mt-4 text-gray-600">
//               To strengthen knowledge dissemination and provide stakeholders
//               with timely insights, the Centre has launched flagship publications
//               and initiatives.
//             </p>
//           </div>
//         </AnimatedSection>

//         <div className="mt-14 grid md:grid-cols-2 gap-x-6 gap-y-10">
//           {flagship.map((item, i) => (
//             <FlagshipCard key={i} item={item} index={i} />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// // function Vision() {
// //   return (
// //     <section className="py-20 md:py-24 bg-[#FFF8F5] relative overflow-hidden">
// //       <div className="absolute -top-24 left-1/4 w-80 h-80 rounded-full bg-[#E8590C]/5 blur-3xl" />
// //       <div className="absolute -bottom-24 right-1/4 w-80 h-80 rounded-full bg-[#B42318]/5 blur-3xl" />

// //       <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">
// //         <AnimatedSection>
// //           <div className="group relative shadow-[0_30px_60px_-24px_rgba(124,20,13,0.55)]">
// //             <div
// //               className="relative overflow-hidden rounded-[32px] p-9 md:p-14"
// //               style={{
// //                 background:
// //                   "linear-gradient(rgb(218, 33, 40), rgb(247, 148, 29))",
// //               }}
// //             >
// //               <div className="pointer-events-none absolute -top-24 -right-16 w-80 h-80 rounded-full bg-[#E8590C]/15 blur-3xl" />
// //               <div className="pointer-events-none absolute -bottom-28 -left-16 w-80 h-80 rounded-full bg-[#B42318]/20 blur-3xl" />
// //               <div className="pointer-events-none absolute inset-0 rounded-[32px] ring-1 ring-inset ring-white/[0.06]" />
// //               <svg className="pointer-events-none absolute inset-0 w-full h-full opacity-[0.5]" xmlns="http://www.w3.org/2000/svg">
// //                 <defs>
// //                   <pattern id="vgrid" width="44" height="44" patternUnits="userSpaceOnUse">
// //                     <path d="M 44 0 L 0 0 0 44" fill="none" stroke="rgba(255,255,255,0.04)" strokeWidth="1" />
// //                   </pattern>
// //                 </defs>
// //                 <rect width="100%" height="100%" fill="url(#vgrid)" />
// //               </svg>

// //               <div className="relative grid lg:grid-cols-12 gap-8 lg:gap-10 items-center">
// //                 <div className="lg:col-span-4" style={{ color: "white" }}>
// //                   <SectionEyebrow className="text-white" variant="dark">Vision Statement</SectionEyebrow>
// //                   <h2 className="mt-5 font-display text-white text-3xl md:text-[40px] leading-[1.1] text-balance">
// //                     A forward-looking{" "}
// //                     <span className="text-[white]">think tank</span> for
// //                     India's future
// //                   </h2>
// //                   <div className="mt-5 h-1 w-14 rounded-full bg-gradient-to-r from-[#F59C00] to-[#E8590C]" />
// //                 </div>

// //                 <div className="lg:col-span-8">
// //                   <blockquote className="relative pl-8 md:pl-10">
// //                     <span
// //                       aria-hidden="true"
// //                       className="absolute -top-8 -left-1 md:left-0 font-display text-[96px] md:text-[120px] leading-none text-[#F59C00] select-none"
// //                     >
// //                       &ldquo;
// //                     </span>
// //                     <p className="relative font-display text-white/90 text-lg md:text-[22px] leading-relaxed text-balance">
// //                       The ASSOCHAM Global Research & Strategy Centre aims to
// //                       become a{" "}
// //                       <span className="text-[white] font-semibold">
// //                         leading think tank
// //                       </span>
// //                       , supporting government and industry with{" "}
// //                       <span className="text-white font-semibold">
// //                         forward-looking policy insights
// //                       </span>{" "}
// //                       and strategic advice in the evolving global economic
// //                       landscape.
// //                     </p>
// //                   </blockquote>
// //                 </div>
// //               </div>
// //             </div>

// //             <div className="absolute -top-5 -right-4 z-10 w-14 h-14 rounded-2xl bg-gradient-to-br from-[#F59C00] to-[#E8590C] text-[white] grid place-items-center shadow-lg shadow-[#E8590C]/40 ring-4 ring-[#F59C00] rotate-6 transition-transform duration-500 group-hover:rotate-0 group-hover:scale-110">
// //               <IconLightbulb className="w-6 h-6" stroke={1.8} />
// //             </div>
// //           </div>
// //         </AnimatedSection>
// //       </div>
// //     </section>
// //   );
// // }

// function Vision() {
//   return (
//     <section className="relative overflow-hidden bg-[#f7f1ea] py-24 md:py-32">
//       <div className="absolute left-0 top-0 h-full w-[26%] bg-[#ebe0d3]" />
//       <div className="absolute right-[10%] top-20 h-44 w-44 rounded-full border border-[#cf4933]/20" />

//       <div className="relative mx-auto max-w-[1200px] px-6 lg:px-10">
//         <div className="grid gap-14 lg:grid-cols-[.72fr_1.5fr] lg:gap-24">
//           <div className="lg:pt-5">
//             <SectionEyebrow>Vision statement</SectionEyebrow>
//             <div className="mt-10 h-px w-full max-w-[180px] bg-[#bf3c2b]" />
//             <p className="mt-5 max-w-xs text-[13px] leading-relaxed text-[#766961]">
//               A forward-looking think tank for India&apos;s future in the global economic landscape.
//             </p>
//           </div>

//           <blockquote className="relative max-w-4xl">
//             <span
//               aria-hidden="true"
//               className="absolute -left-2 -top-16 font-serif text-[150px] leading-none text-[#d55740]/25 md:-left-12 md:text-[220px]"
//             >
//               &ldquo;
//             </span>
//             <p className="relative font-serif text-[clamp(2.25rem,4.3vw,4.8rem)] leading-[1.04] tracking-[-0.045em] text-[#29211e]">
//               To be a <em className="font-normal text-[#b33324]">leading think tank</em>, supporting
//               government and industry with forward-looking policy insight and strategic advice.
//             </p>
//             <footer className="mt-10 flex items-center gap-4 border-t border-[#d3c5b8] pt-5">
//               <span className="grid h-10 w-10 place-items-center rounded-full bg-[#b73727] text-white">
//                 <LightbulbIcon className="h-5 w-5" />
//               </span>
//               <span className="text-[11px] font-bold uppercase tracking-[0.17em] text-[#70645c]">
//                 ASSOCHAM Global Research &amp; Strategy Centre
//               </span>
//             </footer>
//           </blockquote>
//         </div>
//       </div>
//     </section>
//   );
// }

// function Team() {
//   const lead = team.find((t) => t.lead);
//   const rest = team.filter((t) => !t.lead);

//   return (
//     <section className="py-24 md:py-28 bg-white relative overflow-hidden">
//       <div className="absolute inset-0">
//         <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#E8590C]/5 blur-3xl" />
//         <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-[#B42318]/5" />
//         <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-[#E8590C]/5" />
//       </div>

//       <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">
//         <AnimatedSection>
//           <div className="text-center max-w-2xl mx-auto">
//             <SectionEyebrow variant="red">Our Team</SectionEyebrow>
//             <h2 className="text-balance font-display text-3xl md:text-[40px] leading-tight text-gray-900 mt-5">
//               ASSOCHAM Global Research{" "}
//               <span className="text-[#E8590C] relative">
//                 Team
//                 <svg className="absolute -bottom-2 left-0 w-full h-1" viewBox="0 0 100 4">
//                   <line x1="0" y1="2" x2="100" y2="2" stroke="currentColor" strokeWidth="2" strokeDasharray="8 8" className="text-[#E8590C]/50" />
//                 </svg>
//               </span>
//             </h2>
//             <p className="mt-4 text-gray-600">
//               A dedicated team of economists and policy experts driving our
//               research agenda.
//             </p>
//           </div>
//         </AnimatedSection>

//         <AnimatedSection delay={150}>
//           <div className="mt-14 flex flex-col items-center text-center">
//             <div className="relative group">
//               <div className="absolute -inset-3 rounded-full bg-gradient-to-br from-[#E8590C] via-[#B42318] to-[#F59C00] blur-md opacity-70 animate-pulse" />
//               <div className="relative w-32 h-32 rounded-full overflow-hidden ring-4 ring-white shadow-lg">
//                 <img
//                   src={lead.photo}
//                   alt={lead.name}
//                   onError={(e) => onImgError(e, lead.name)}
//                   className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//                 />
//               </div>
//             </div>
//             <h3 className="mt-5 font-display text-2xl text-gray-900">
//               {lead.name}
//             </h3>
//             <div className="text-sm font-semibold text-[#B42318] mt-1">
//               {lead.role}
//             </div>
//             <div className="mt-3 flex flex-col sm:flex-row items-center gap-2 sm:gap-5 text-xs text-gray-600">
//               <span className="inline-flex items-center gap-2">
//                 <IconPhone className="w-3.5 h-3.5 text-[#7c140d]" />
//                 {lead.phone}
//               </span>
//               <span className="inline-flex items-center gap-2">
//                 <IconMail className="w-3.5 h-3.5 text-[#7c140d]" />
//                 {lead.email}
//               </span>
//             </div>
//             <a
//               href="#"
//               aria-label={`${lead.name} on LinkedIn`}
//               className="mt-4 w-8 h-8 rounded-full bg-[#B42318] text-white flex items-center justify-center hover:bg-[#7c140d] transition-all duration-300 hover:scale-110 hover:rotate-12"
//             >
//               <IconLinkedIn className="w-3.5 h-3.5" />
//             </a>
//           </div>
//         </AnimatedSection>

//         <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
//           {rest.map((m, i) => (
//             <AnimatedCard key={i} delay={i * 100}>
//               <div className="group relative h-full bg-white rounded-2xl p-6 text-center ring-1 ring-[#E8590C]/10 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-2 overflow-hidden">
//                 <div className="pointer-events-none absolute -top-10 -right-10 w-24 h-24 rounded-full bg-[#E8590C]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
//                 <div className="relative w-24 h-24 mx-auto">
//                   <div className="absolute -inset-1.5 rounded-full bg-gradient-to-br from-[#E8590C]/60 to-[#B42318]/60 blur-sm opacity-70 group-hover:opacity-100 transition-opacity duration-300" />
//                   <div className="relative w-24 h-24 rounded-full overflow-hidden ring-4 ring-white">
//                     <img
//                       src={m.photo}
//                       alt={m.name}
//                       onError={(e) => onImgError(e, m.name)}
//                       className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//                     />
//                   </div>
//                 </div>
//                 <h4 className="mt-4 font-semibold text-gray-900 text-sm leading-snug">
//                   {m.name}
//                 </h4>
//                 <div className="text-[11px] font-semibold uppercase tracking-wider text-[#7c140d] mt-1">
//                   {m.role}
//                 </div>
//                 <div className="mt-3 text-[11px] text-gray-500">
//                   {m.phone ? (
//                     <div className="space-y-1">
//                       <div className="inline-flex items-center gap-1.5">
//                         <IconPhone className="w-3 h-3" />
//                         {m.phone}
//                       </div>
//                       <div className="truncate inline-flex items-center gap-1.5 max-w-full">
//                         <IconMail className="w-3 h-3 shrink-0" />
//                         <span className="truncate">{m.email}</span>
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="inline-flex items-center gap-1.5 text-gray-400">
//                       <span className="w-1 h-1 rounded-full bg-[#E8590C]/60" />
//                       {m.dept || "Research & Strategy"}
//                     </div>
//                   )}
//                 </div>
//                 <a
//                   href="#"
//                   aria-label={`${m.name} on LinkedIn`}
//                   className="mt-4 inline-flex w-7 h-7 rounded-full bg-[#FAF7F2] text-[#B42318] items-center justify-center hover:bg-[#B42318] hover:text-white transition-all duration-300 hover:scale-110 hover:rotate-12"
//                 >
//                   <IconLinkedIn className="w-3 h-3" />
//                 </a>
//               </div>
//             </AnimatedCard>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// /* --------------------------- Aggregated page body -------------------------- */
// export default function GlobalResearch() {
//   return (
//     <main className="overflow-hidden">
//       <Hero />
//       <About />
//       <FocusAreas />
//       {/* <Flagships /> */}
//       <FlagshipInitiatives />
//       <Vision />
//       <Team />
//     </main>
//   );
// }






// new new code 




import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import FlagshipInitiatives from './FlagshipInitiatives'
import { Compass, Eye } from "lucide-react";

/* ============================================================================
   ASSOCHAM Global Research & Strategy Centre
   Single-file, self-contained page component.
   Layout follows the approved wireframe 1:1 (Header -> Hero -> About ->
   Focus Areas -> Flagship Initiatives -> Vision -> Team -> Contact), styled
   with the ASSOCHAM red/orange palette and scroll-triggered animation.
   All icons are inline SVG so this file has zero external icon dependencies.
   ========================================================================== */

/* ------------------------------- Icon set --------------------------------- */
/* Every icon shares the same stroke-based style so nothing looks mismatched. */

const iconBase = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const IconArrow = ({ className = "w-4 h-4", stroke = 2 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <path d="M5 12h14" />
    <path d="M13 6l6 6-6 6" />
  </svg>
);

const IconChart = ({ className = "w-6 h-6", stroke = 1.8 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <path d="M4 20V10" />
    <path d="M10 20V4" />
    <path d="M16 20v-7" />
    <path d="M22 20H2" />
    <path d="M15 7l5-3" />
  </svg>
);

const IconPolicy = ({ className = "w-6 h-6", stroke = 1.8 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <rect x="5" y="3" width="14" height="18" rx="1.5" />
    <path d="M9 8h6" />
    <path d="M9 12h6" />
    <circle cx="16.5" cy="16.5" r="3.2" />
    <path d="M18.7 18.7L21 21" />
  </svg>
);

const IconGear = ({ className = "w-6 h-6", stroke = 1.8 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <circle cx="12" cy="12" r="3.2" />
    <path d="M12 3v2.2M12 18.8V21M4.9 4.9l1.6 1.6M17.5 17.5l1.6 1.6M3 12h2.2M18.8 12H21M4.9 19.1l1.6-1.6M17.5 6.5l1.6-1.6" />
  </svg>
);

const IconGlobe = ({ className = "w-6 h-6", stroke = 1.8 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18" />
    <path d="M12 3c2.7 2.5 4.2 5.7 4.2 9s-1.5 6.5-4.2 9c-2.7-2.5-4.2-5.7-4.2-9S9.3 5.5 12 3z" />
  </svg>
);

const IconCap = ({ className = "w-6 h-6", stroke = 1.8 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <path d="M2 9l10-4.5L22 9l-10 4.5L2 9z" />
    <path d="M6 11v5c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5v-5" />
    <path d="M22 9v6" />
  </svg>
);

const IconBook = ({ className = "w-6 h-6", stroke = 1.8 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <path d="M4 5.5C4 4.7 4.7 4 5.5 4H12v16H5.5c-.8 0-1.5-.7-1.5-1.5v-13z" />
    <path d="M20 5.5c0-.8-.7-1.5-1.5-1.5H12v16h6.5c.8 0 1.5-.7 1.5-1.5v-13z" />
  </svg>
);

const IconBuilding = ({ className = "w-6 h-6", stroke = 1.8 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <path d="M4 21V6l8-3 8 3v15" />
    <path d="M2 21h20" />
    <path d="M9 21v-5h6v5" />
    <path d="M8 9h.01M12 9h.01M16 9h.01M8 13h.01M12 13h.01M16 13h.01" />
  </svg>
);

const IconTarget = ({ className = "w-6 h-6", stroke = 1.8 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="5" />
    <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
  </svg>
);

const IconPhone = ({ className = "w-4 h-4", stroke = 2 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <path d="M4 4.5c0-.6.4-1 1-1h2.6c.5 0 .9.3 1 .8l.8 3.3c.1.4 0 .8-.3 1.1L7.6 10c1 2.4 3 4.4 5.4 5.4l1.3-1.5c.3-.3.7-.4 1.1-.3l3.3.8c.5.1.8.5.8 1V18c0 .6-.4 1-1 1h-1C9.9 19 5 14.1 5 8V5c0-.2 0-.4-.1-.5H4z" />
  </svg>
);

const IconMail = ({ className = "w-4 h-4", stroke = 2 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <rect x="3" y="5" width="18" height="14" rx="1.5" />
    <path d="M3.5 6l8.5 7 8.5-7" />
  </svg>
);

const IconPin = ({ className = "w-5 h-5", stroke = 1.8 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <path d="M12 21s-6.7-5.9-6.7-11A6.7 6.7 0 1 1 18.7 10c0 5.1-6.7 11-6.7 11z" />
    <circle cx="12" cy="10" r="2.3" />
  </svg>
);

const IconMap = ({ className = "w-5 h-5", stroke = 1.8 }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={stroke} {...iconBase}>
    <path d="M9 3L3 5.5v15L9 18l6 2.5 6-2.5v-15L15 5.5 9 3z" />
    <path d="M9 3v15" />
    <path d="M15 5.5v15" />
  </svg>
);

const IconLinkedIn = ({ className = "w-3.5 h-3.5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M4.98 3.5C4.98 4.9 3.9 6 2.5 6S0 4.9 0 3.5 1.1 1 2.5 1s2.48 1.1 2.48 2.5zM.24 8.25h4.5V23H.24V8.25zM8.1 8.25h4.32v2.02h.06c.6-1.13 2.06-2.32 4.24-2.32 4.53 0 5.37 2.98 5.37 6.86V23h-4.5v-6.36c0-1.52-.03-3.47-2.12-3.47-2.12 0-2.44 1.65-2.44 3.36V23H8.1V8.25z" />
  </svg>
);

const IconMenu = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={2} {...iconBase}>
    <path d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

const IconClose = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" className={className} strokeWidth={2} {...iconBase}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

/* ---------------------------- Section eyebrow ------------------------------ */
const SectionEyebrow = ({ children, variant = "red" }) => {
  const styles = {
    red: "text-[#B42318] border-[#B42318]/20 bg-[#B42318]/5",
    orange: "text-[#E8590C] border-[#E8590C]/20 bg-[#E8590C]/5",
  };
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-1 text-[11px] font-bold uppercase tracking-[0.14em] ${styles[variant]}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {children}
    </span>
  );
};

/* ------------------------------- Data blocks ------------------------------ */

const navLinks = [
  { label: "About", href: "#about" },
  { label: "Research", href: "#focus" },
  { label: "Publications", href: "#initiatives" },
  { label: "Team", href: "#team" },
  { label: "Contact", href: "#contact" },
];

const focusAreas = [
  {
    icon: IconChart,
    title: "Economic Growth & Development",
    body: "Strengthening research for sustainable economic growth.",
  },
  {
    icon: IconPolicy,
    title: "Public Policy Analysis",
    body: "Providing analytical insights for effective policy formulation.",
  },
  {
    icon: IconGear,
    title: "Ease of Doing Business (EoDB)",
    body: "Promoting a business-friendly environment through research and policy recommendations.",
  },
  {
    icon: IconGlobe,
    title: "Trade & Investment Promotion (TIPS)",
    body: "Supporting trade and investment through strategic insights and partnerships.",
  },
  {
    icon: IconCap,
    title: "Industry-Academia Collaboration",
    body: "Building strong linkages between academia and industry for knowledge and innovation.",
  },
];

const flagship = [
  {
    icon: IconChart,
    title: "Economic Growth & Development",
    body: "Evidence-based research and analysis on key sectors, working papers, and thematic studies.",
    buttonText: "Explore Reports",
    to: "/global-research/economic-growth",
  },
  {
    icon: IconPolicy,
    title: "Ease of Doing Business (EoDB)",
    body: "Research, policy analysis, and stakeholder engagement to improve the regulatory environment.",
    buttonText: "Learn More",
    to: "/global-research/eodb",
  },
  {
    icon: IconGlobe,
    title: "Trade & Investment Promotion Services (TIPS)",
    body: "A knowledge and advisory platform providing insights on investment opportunities and trade intelligence.",
    buttonText: "Visit TIPS",
    to: "/global-research/tips",
  },
  {
    icon: IconBook,
    title: "Publications",
    body: "Timely research and economic intelligence to support informed decision-making.",
    bullets: [
      "ASSOCHAM Business Currents Daily (ABC Daily)",
      "ASSOCHAM India Monitor (AIM Weekly)",
      "ASSOCHAM Global Economic Outlook (GEO Monthly)",
    ],
    buttonText: "View Publications",
    to: "/global-research/publications",
  },
];

const team = [
  {
    name: "Dr. S.P. Sharma",
    role: "Chief Economist",
    phone: "011-46550555",
    email: "chiefeconomist@assocham.com",
    photo: "/OurTeam/S_P_Sharma.jpg",
    lead: true,
  },
  {
    name: "Ms. Ruchi Singhal",
    role: "Additional Director",
    dept: "Research & Strategy",
    photo: "/OurTeam/RuchiSinghal.png",
  },
  {
    name: "Ms. Yatika Gupta",
    role: "Joint Director",
    dept: "Research & Strategy",
    photo: "https://assocham.org/assocham_backend/images/awards/img14.png",
  },
  {
    name: "Mr. Arun Singh Rathore",
    role: "Deputy Director",
    dept: "Research & Strategy",
    photo: "/OurTeam/Arun_Singh_Rathore.jpg",
  },
  {
    name: "Ms. Avneet Kaur",
    role: "Senior Executive",
    dept: "Research & Strategy",
    photo: "/OurTeam/Avneet_Kaur.jpg",
  },
];

const contactInfo = [
  {
    icon: IconPin,
    label: "Address",
    lines: ["ASSOCHAM Headquarters", "4th Floor, YMCA Cultural Centre,", "New Delhi - 110001"],
  },
  {
    icon: IconPhone,
    label: "Phone",
    lines: ["011-46550555"],
    href: "tel:+911146550555",
  },
  {
    icon: IconMail,
    label: "Email",
    lines: ["chiefeconomist@assocham.com"],
    href: "mailto:chiefeconomist@assocham.com",
  },
  {
    icon: IconMap,
    label: "Location",
    lines: ["View on Map"],
    href: "https://maps.google.com/?q=ASSOCHAM+New+Delhi",
  },
];

/* --------------------------- Image resilience ---------------------------- */
const initialsOf = (name = "") =>
  name
    .replace(/[^a-zA-Z.\s]/g, "")
    .split(/[\s.]+/)
    .filter(Boolean)
    .slice(-2)
    .map((w) => w[0])
    .join("")
    .toUpperCase() || "?";

const avatarFallback = (name = "") => {
  const initials = initialsOf(name);
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'><defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='#e8590c'/><stop offset='1' stop-color='#7c140d'/></linearGradient></defs><rect width='240' height='240' fill='url(#g)'/><text x='50%' y='54%' font-family='Space Grotesk, Arial' font-size='92' font-weight='600' fill='white' text-anchor='middle' dominant-baseline='middle'>${initials}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

const onImgError = (e, name) => {
  const el = e.currentTarget;
  if (el.dataset.fallback === "1") return;
  el.dataset.fallback = "1";
  el.src = avatarFallback(name);
};

/* ------------------------------- Animations ------------------------------ */
const useIntersectionObserver = (options = {}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1, ...options }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [ref, isVisible];
};

const AnimatedSection = ({ children, className = "", delay = 0 }) => {
  const [ref, isVisible] = useIntersectionObserver();
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

const AnimatedCard = ({ children, className = "", delay = 0 }) => {
  const [ref, isVisible] = useIntersectionObserver();
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-[0.97]"
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

/* Breadcrumb — matches the AboutSection breadcrumb styling */
function Breadcrumb() {
  return (
    <nav
      aria-label="Breadcrumb"
      className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
    >
      <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
        <li>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
          >
            <svg
              viewBox="0 0 24 24"
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 10.5 12 3l9 7.5" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
            Home
          </a>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">
          Global Research
        </li>
      </ol>
    </nav>
  );
}

/* --------------------------------- Header --------------------------------- */

 

/* ---------------------------------- Hero ----------------------------------- */
function Hero() {
  return (
    <header id="top" className="relative overflow-hidden bg-[#FAF7F2]">
      <div className="hero-grid absolute inset-0 opacity-60" />
      <Breadcrumb />
      <div className="pointer-events-none absolute -top-32 left-1/2 h-[360px] w-[680px] -translate-x-1/2 rounded-full bg-[#DA2128]/10 blur-[130px]" />
      <div className="pointer-events-none absolute -bottom-40 -right-24 h-[320px] w-[320px] rounded-full bg-[#DA2128]/[0.07] blur-[110px]" />

      <div className="relative w-full  mx-auto px-6 lg:px-10 py-20 sm:py-24">
        <div className="grid  gap-8 items-center">
          {/* left flanking image */}
         
          {/* center content */}
          <AnimatedSection delay={200}>
            <div className="max-w-2xl mx-auto text-center">
             
              <h1 className="font-display text-gray-900 text-3xl sm:text-4xl md:text-[28px] leading-[1.08] tracking-tight [text-wrap:balance]">
                ASSOCHAM Global Research &{" "}
                <span className="relative text-[#B42318]">
                  Strategy Centre
                  <svg className="absolute -bottom-2 left-0 w-full h-1.5" viewBox="0 0 100 4" preserveAspectRatio="none">
                    <line x1="0" y1="2" x2="100" y2="2" stroke="currentColor" strokeWidth="2.5" strokeDasharray="7 7" className="text-[#E8590C]/50" />
                  </svg>
                </span>
              </h1>

              <div className="mt-5 flex items-center justify-center gap-3 text-[13px] font-bold uppercase tracking-[0.2em] text-[#B42318]/80">
                <span>Research</span>
                <span className="w-1 h-1 rounded-full bg-[#E8590C]" />
                <span>Policy</span>
                <span className="w-1 h-1 rounded-full bg-[#E8590C]" />
                <span>Strategy</span>
              </div>

              <p className="mt-6 text-gray-600 leading-relaxed text-[15px] md:text-[16.5px]">
                A dedicated platform for research, policy analysis, and strategic insights aimed at
                strengthening India's position in the global economy.
              </p>

              <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
                <a
                  href="#focus"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("focus")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#B42318] to-[#E8590C] hover:from-[#94190f] hover:to-[#c94c09] transition-all duration-300 text-white text-sm font-semibold px-6 py-3 shadow-lg shadow-[#E8590C]/25 hover:shadow-xl hover:-translate-y-0.5"
                >
                  Explore Research
                  <IconArrow className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" stroke={2.2} />
                </a>
                <a
                  href="#initiatives"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("initiatives")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="inline-flex items-center gap-2 rounded-full border border-[#B42318]/25 hover:border-[#B42318]/50 hover:bg-white/60 transition-colors duration-300 text-gray-800 text-sm font-semibold px-6 py-3 backdrop-blur"
                >
                  Publications
                </a>
              </div>
            </div>
          </AnimatedSection>

         
        </div>
      </div>

      <div className="shimmer-line h-px w-full" />

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-14px); }
        }
        .hero-grid {
          background-image: linear-gradient(rgba(180,35,24,0.035) 1px, transparent 1px),
            linear-gradient(90deg, rgba(180,35,24,0.035) 1px, transparent 1px);
          background-size: 42px 42px;
          mask-image: radial-gradient(ellipse 60% 60% at 50% 30%, #000 40%, transparent 100%);
        }
        .shimmer-line {
          background: linear-gradient(90deg, transparent, rgba(232,89,12,0.35), transparent);
        }
      `}</style>
    </header>
  );
}

/* ---------------------------------- About ----------------------------------- */
function About() {
  return (
    <section className="py-24 md:py-28 bg-[#FAF7F2]">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <AnimatedSection>
          <div>
            <SectionEyebrow variant="orange">About the Centre</SectionEyebrow>
            <h2 className="text-balance font-display text-3xl md:text-[32px] leading-tight text-gray-900 mt-5">
              Driving India's Position in the{" "}
              <span className="text-[#B42318] relative">
                Global Economy
                <svg className="absolute -bottom-2 left-0 w-full h-1" viewBox="0 0 100 4">
                  <line x1="0" y1="2" x2="100" y2="2" stroke="currentColor" strokeWidth="2" strokeDasharray="6 6" className="text-[#B42318]/50" />
                </svg>
              </span>
            </h2>
            <div className="mt-6 space-y-4 text-gray-600 leading-relaxed max-w-xl">
              <p>
                The ASSOCHAM Global Research & Strategy Centre is a dedicated
                platform for research, policy analysis, and strategic insights
                aimed at strengthening India's position in the global economy.
              </p>
              <p>
                Through high-quality research, thought leadership, and
                evidence-based recommendations, the Centre supports informed
                policymaking, promotes sustainable economic growth, and
                contributes to India's development journey.
              </p>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={200}>
          <div className="relative">
            <div className="absolute -inset-4 rounded-[28px] bg-gradient-to-br from-[#E8590C]/25 via-[#B42318]/15 to-[#F59C00]/25 blur-2xl animate-pulse" />
            <div className="relative rounded-3xl overflow-hidden ring-1 ring-[#E8590C]/20 shadow-2xl shadow-[#B42318]/10">
              <img
                src="https://images.pexels.com/photos/7876664/pexels-photo-7876664.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=800&w=1200"
                alt="Global economy research"
                className="w-full h-[380px] object-cover transition-transform duration-700 hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#7c140d]/40 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-white/90 backdrop-blur flex items-center justify-center text-[#B42318]">
                  <IconChart className="w-5 h-5" />
                </div>
                <div className="text-white">
                  <div className="text-sm font-semibold">
                    Global Economic Insights
                  </div>
                  <div className="text-xs text-white/80">
                    Data-driven policy briefings
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}

function FocusCard({ f, index }) {
  return (
    <AnimatedCard delay={index * 90}>
      <div className="group relative h-full bg-white rounded-2xl p-7 ring-1 ring-[#E8590C]/10 shadow-sm hover:shadow-xl hover:shadow-[#E8590C]/10 transition-all duration-300 hover:-translate-y-2 overflow-hidden">
        <span
          aria-hidden="true"
          className="pointer-events-none absolute top-4 right-5 z-0 font-display text-[52px] leading-none font-bold text-transparent [-webkit-text-stroke:1px_rgba(180,35,24,0.16)] transition-all duration-300 group-hover:[-webkit-text-stroke:1.5px_rgba(232,89,12,0.5)]"
        />
        <div className="pointer-events-none absolute -top-12 -right-12 w-32 h-32 rounded-full bg-gradient-to-br from-[#E8590C]/5 to-[#B42318]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

        <div className="relative z-10">
          <div className="w-12 h-12 rounded-xl bg-[#FAF7F2] flex items-center justify-center text-[#7c140d] ring-1 ring-[#E8590C]/20 transition-all duration-300 group-hover:bg-[#E8590C] group-hover:text-white group-hover:scale-110 group-hover:rotate-12">
            <f.icon className="w-6 h-6" />
          </div>
          <h3 className="mt-5 font-display text-xl text-gray-900 leading-snug pr-10">
            {f.title}
          </h3>
          <p className="mt-3 text-sm leading-relaxed text-gray-600">{f.body}</p>
          <div className="mt-5 h-1 w-10 rounded-full bg-gradient-to-r from-[#B42318] to-[#E8590C] transition-all duration-300 group-hover:w-20" />
        </div>
      </div>
    </AnimatedCard>
  );
}

function FocusAreas() {
  return (
    <section id="focus" className="pb-24 md:pb-28 relative bg-[#FFF8F5]">
      <div className="absolute inset-0">
        <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1.5" fill="rgba(180,35,24,0.03)" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#dots)" />
        </svg>
      </div>
 
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">
        <AnimatedSection>
          <div className="text-center max-w-2xl mx-auto">
            <SectionEyebrow variant="red">Key Focus Areas</SectionEyebrow>
            <h2 className="text-balance font-display text-3xl md:text-[32px] leading-tight text-gray-900 mt-5">
              Unlocking Emerging{" "}
              <span className="text-[#E8590C] relative">
                Opportunities
                <svg className="absolute -bottom-2 left-0 w-full h-1" viewBox="0 0 100 4">
                  <line x1="0" y1="2" x2="100" y2="2" stroke="currentColor" strokeWidth="2" strokeDasharray="8 8" className="text-[#E8590C]/50" />
                </svg>
              </span>
            </h2>
            <p className="mt-4 text-gray-600">
              The ASSOCHAM Global Research & Strategy Centre focuses on unlocking
              emerging opportunities and driving sustainable economic growth
              through the following key areas.
            </p>
          </div>
        </AnimatedSection>
 
        <div className="mt-12 flex flex-wrap justify-center gap-5">
          {focusAreas.map((f, i) => (
            <AnimatedCard
              key={i}
              delay={i * 90}
              className="w-full sm:w-[calc(50%-10px)] lg:w-[calc(33.333%-14px)]"
            >
              <FocusCard f={f} />
            </AnimatedCard>
          ))}
        </div>
      </div>
    </section>
  );
}

const NOTCH_MASK =
  "radial-gradient(circle 30px at calc(100% - 26px) calc(100% - 26px), transparent 0, transparent 27.5px, #000 28.5px, #000 100%)";

function FlagshipCard({ item, index }) {
  const Icon = item.icon;
  return (
    <AnimatedCard delay={index * 100} className="h-full">
      <div className="group relative h-full transition-transform duration-300 ease-out hover:-translate-y-1.5 shadow-[0_22px_45px_-20px_rgba(124,20,13,0.55)] hover:shadow-[0_34px_60px_-18px_rgba(180,35,24,0.6)]">
        <div
          className="relative h-full min-h-[300px] flex flex-col rounded-[28px] p-7 md:p-8 overflow-hidden"
          style={{
            background:
              "linear-gradient(rgb(218, 33, 40), rgb(247, 148, 29))",
            WebkitMaskImage: NOTCH_MASK,
            maskImage: NOTCH_MASK,
          }}
        >
          <div className="pointer-events-none absolute -top-20 -left-12 w-60 h-60 rounded-full bg-[#E8590C]/15 blur-3xl opacity-60 transition-opacity duration-500 group-hover:opacity-100" />
          <div className="pointer-events-none absolute -bottom-24 left-1/4 w-64 h-64 rounded-full bg-[#B42318]/20 blur-3xl" />
          <div className="pointer-events-none absolute inset-0 rounded-[28px] ring-1 ring-inset ring-white/[0.05]" />
          <div className="pointer-events-none absolute top-0 left-8 right-8 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent opacity-60 transition-opacity duration-500 group-hover:opacity-100" />

          <h3 className="relative font-display text-[19px] md:text-[22px] font-medium text-white leading-snug pr-6">
            {item.title}
          </h3>

          <p className="relative mt-3 text-[13.5px] leading-relaxed text-white">
            {item.body}
          </p>

          {item.bullets && (
            <ul className="relative mt-4 space-y-2">
              {item.bullets.map((b, i) => (
                <li
                  key={i}
                  className="flex items-start gap-2.5 text-[13px] leading-snug text-white"
                >
                  <span className="mt-[7px] w-1.5 h-1.5 rounded-full bg-[#F59C00] shrink-0 shadow-[0_0_8px_rgba(245,158,11,0.6)]" />
                  {b}
                </li>
              ))}
            </ul>
          )}

          <div className="relative mt-auto pt-7 flex items-end justify-between gap-4 pr-14">
            <Icon
              stroke={1.25}
              className="w-14 h-14 md:w-[68px] md:h-[68px] text-white shrink-0 transition-all duration-300 group-hover:text-[#DA2128] group-hover:-translate-y-0.5 group-hover:scale-[1.04] drop-shadow-[0_2px_10px_rgba(0,0,0,0.35)]"
            />
            <span className="text-right text-[13px] font-semibold tracking-wide text-white/70 transition-colors duration-300 group-hover:text-white">
              {item.buttonText}
            </span>
          </div>
        </div>

        <Link
          to={item.to}
          aria-label={item.buttonText}
          className="absolute right-1 bottom-1 z-10 grid place-items-center w-11 h-11 rounded-full bg-[#190705] text-white/85 ring-1 ring-white/12 transition-all duration-300 group-hover:bg-[#F59C00] group-hover:text-white group-hover:ring-[#F59C00]/50 group-hover:scale-105 group-hover:-rotate-[8deg]"
        >
          <IconArrow className="w-[18px] h-[18px]" stroke={2.2} />
        </Link>
      </div>
    </AnimatedCard>
  );
}

function Flagships() {
  return (
    <section id="initiatives" className="py-24 md:py-28 bg-[#FAF7F2] relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-[#E8590C]/5" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 rounded-full bg-[#B42318]/5" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-gradient-to-r from-[#E8590C]/3 to-[#B42318]/3 blur-3xl" />
        <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(180,35,24,0.03)" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">
        <AnimatedSection>
          <div className="text-center max-w-2xl mx-auto">
           
            <h2 className="font-display text-3xl md:text-[40px] leading-tight text-gray-900 mt-5">
               Flagship Publications & Initiatives
            </h2>
            <p className="mt-4 text-gray-600">
              To strengthen knowledge dissemination and provide stakeholders
              with timely insights, the Centre has launched flagship publications
              and initiatives.
            </p>
          </div>
        </AnimatedSection>

        <div className="mt-14 grid md:grid-cols-2 gap-x-6 gap-y-10">
          {flagship.map((item, i) => (
            <FlagshipCard key={i} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}


/* ------------------------------- Vision statement ---------------------------- */
function Vision() {
  return (
    <section className="relative overflow-hidden bg-[#f7f1ea] py-20 md:py-24">
      <div className="pointer-events-none absolute -top-24 left-1/4 h-80 w-80 rounded-full bg-[#E8590C]/5 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 right-1/4 h-80 w-80 rounded-full bg-[#B42318]/5 blur-3xl" />

      <div className="relative mx-auto max-w-[820px] px-6 lg:px-10 text-center">
        <AnimatedSection>
          {/* Icon + Title */}
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="grid h-10 w-10 place-items-center rounded-2xl bg-gradient-to-br from-[#DA2128] to-[#F7941D] text-white shadow-lg shadow-[#B42318]/20">
             <Compass className="h-8 w-8" strokeWidth={2.2} />
            </div>

            <SectionEyebrow
              variant="orange"
              className="!mt-0 text-xl md:text-2xl font-bold"
            >
              Vision Statement
            </SectionEyebrow>
          </div>

          {/* Content */}
          <p className="mx-auto mt-4 max-w-3xl font-display text-lg leading-relaxed tracking-tight text-[#29211e] md:text-xl lg:text-2xl">
            To be a{" "}
            <span className="font-semibold text-[#B42318]">
              leading think tank
            </span>{" "}
            delivering forward-looking research, strategic insights, and
            evidence-based recommendations for inclusive and sustainable
            economic growth.
          </p>
        </AnimatedSection>
      </div>
    </section>
  );
}

/* ---------------------------------- Team ------------------------------------ */
function Team() {
  const lead = team.find((t) => t.lead);
  const rest = team.filter((t) => !t.lead);

  return (
    <section className="py-24 md:py-28 bg-white relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#E8590C]/5 blur-3xl" />
        <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-[#B42318]/5" />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-[#E8590C]/5" />
      </div>

      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">
        <AnimatedSection>
          <div className="text-center max-w-2xl mx-auto">
            <SectionEyebrow variant="red">Our Team</SectionEyebrow>
            <h2 className="text-balance font-display text-3xl md:text-[32px] leading-tight text-gray-900 mt-5">
              ASSOCHAM Global Research{" "}
              <span className="text-[#E8590C] relative">
                Team
                <svg className="absolute -bottom-2 left-0 w-full h-1" viewBox="0 0 100 4">
                  <line x1="0" y1="2" x2="100" y2="2" stroke="currentColor" strokeWidth="2" strokeDasharray="8 8" className="text-[#E8590C]/50" />
                </svg>
              </span>
            </h2>
            <p className="mt-4 text-gray-600">
              A dedicated team of economists and policy experts driving our
              research agenda.
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={150}>
          <div className="mt-14 flex flex-col items-center text-center">
            <div className="relative group">
              <div className="absolute -inset-3 rounded-full bg-gradient-to-br from-[#E8590C] via-[#B42318] to-[#F59C00] blur-md opacity-70 animate-pulse" />
              <div className="relative w-32 h-32 rounded-full overflow-hidden ring-4 ring-white shadow-lg">
                <img
                  src={lead.photo}
                  alt={lead.name}
                  onError={(e) => onImgError(e, lead.name)}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
            </div>
            <h3 className="mt-5 font-display text-2xl text-gray-900">
              {lead.name}
            </h3>
            <div className="text-sm font-semibold text-[#B42318] mt-1">
              {lead.role}
            </div>
            <div className="mt-3 flex flex-col sm:flex-row items-center gap-2 sm:gap-5 text-xs text-gray-600">
              <span className="inline-flex items-center gap-2">
                <IconPhone className="w-3.5 h-3.5 text-[#7c140d]" />
                {lead.phone}
              </span>
              <span className="inline-flex items-center gap-2">
                <IconMail className="w-3.5 h-3.5 text-[#7c140d]" />
                {lead.email}
              </span>
            </div>
            <a
              href="#"
              aria-label={`${lead.name} on LinkedIn`}
              className="mt-4 w-8 h-8 rounded-full bg-[#B42318] text-white flex items-center justify-center hover:bg-[#7c140d] transition-all duration-300 hover:scale-110 hover:rotate-12"
            >
              <IconLinkedIn className="w-3.5 h-3.5" />
            </a>
          </div>
        </AnimatedSection>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          {rest.map((m, i) => (
            <AnimatedCard key={i} delay={i * 100}>
              <div className="group relative h-full bg-white rounded-2xl p-6 text-center ring-1 ring-[#E8590C]/10 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-2 overflow-hidden">
                <div className="pointer-events-none absolute -top-10 -right-10 w-24 h-24 rounded-full bg-[#E8590C]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="relative w-24 h-24 mx-auto">
                  <div className="absolute -inset-1.5 rounded-full bg-gradient-to-br from-[#E8590C]/60 to-[#B42318]/60 blur-sm opacity-70 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="relative w-24 h-24 rounded-full overflow-hidden ring-4 ring-white">
                    <img
                      src={m.photo}
                      alt={m.name}
                      onError={(e) => onImgError(e, m.name)}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>
                </div>
                <h4 className="mt-4 font-semibold text-gray-900 text-sm leading-snug">
                  {m.name}
                </h4>
                <div className="text-[11px] font-semibold uppercase tracking-wider text-[#7c140d] mt-1">
                  {m.role}
                </div>
                <div className="mt-3 text-[11px] text-gray-500">
                  {m.phone ? (
                    <div className="space-y-1">
                      <div className="inline-flex items-center gap-1.5">
                        <IconPhone className="w-3 h-3" />
                        {m.phone}
                      </div>
                      <div className="truncate inline-flex items-center gap-1.5 max-w-full">
                        <IconMail className="w-3 h-3 shrink-0" />
                        <span className="truncate">{m.email}</span>
                      </div>
                    </div>
                  ) : (
                    <div className="inline-flex items-center gap-1.5 text-gray-400">
                      <span className="w-1 h-1 rounded-full bg-[#E8590C]/60" />
                      {m.dept || "Research & Strategy"}
                    </div>
                  )}
                </div>
                <a
                  href="#"
                  aria-label={`${m.name} on LinkedIn`}
                  className="mt-4 inline-flex w-7 h-7 rounded-full bg-[#FAF7F2] text-[#B42318] items-center justify-center hover:bg-[#B42318] hover:text-white transition-all duration-300 hover:scale-110 hover:rotate-12"
                >
                  <IconLinkedIn className="w-3 h-3" />
                </a>
              </div>
            </AnimatedCard>
          ))}
        </div>
      </div>
    </section>
  );
}

/* --------------------------- Aggregated page body -------------------------- */
export default function GlobalResearch() {
  return (
    <main className="overflow-hidden font-sans">
   
      <Hero />
      <About />
      <FocusAreas />
      <FlagshipInitiatives />
      <Vision />
      <Team />
    </main>
  );
}